<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import DocsNavBar from "./components/DocsNavBar.vue";

const store = useStore();
const windowWidth = ref(window.innerWidth);

// Detectar cambios de tamaño
const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWindowWidth);
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  document.body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowWidth);
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  document.body.classList.add("bg-gray-100");
});

</script>

<template>
  <div class="container-fluid vh-100">
    <div class="row h-100">
      <!-- Navbar lateral -->
      <div class="col-12 col-md-2">
        <DocsNavBar />
      </div>
      <!-- Contenido principal -->
      <main class="col-12 col-md-10 overflow-auto p-7">
        
        <!-- Sección del manual de usuario (Inicio de Sesión) -->
        <hr>
        <h3> Manual de Usuario - Inicio de Sesión <br><img src="../../assets/img/user-manual/UserManual-2.gif" alt=""> </h3>
        <section class="mt-4">
          <hr>
          <p class="text-gray-700">
            <u><b>  Última Revisión:</b></u> 27/03/2025 <br><br>
            Bienvenid@ a esta breve guía que le ayudará a conocer el proceso de inicio de sesión dentro de esta nueva plataforma.<br>
          </p>
          <hr>

          <div class="mt-4">
            <h4 class="text-xl font-semibold"> <i class="bi bi-caret-right-fill"></i> Inicio de Sesión.</h4>
          </div>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 1 - Acceder al apartado de inicio de sesión</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualSignIn-1.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Dentro de la página de <a href="https://app.nexonautomation.com/signin"> <b>inicio de sesión</b></a> , podras encontrar el siguiente formulario.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 2 - Ingresar claves de acceso</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualSignIn-2.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Una vez dentro de la página de inicio de sesión, tendrás que rellenar los campos de Correo y Contraseña de tu cuenta Nexon previamente creada.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 3 - Acceda a la plataforma Nexon</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualSignIn-3.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Una vez que haya rellenado correctamente los campos de Correo electrónico y Contraseña, debe hacer clic en el botón «Iniciar sesión», en caso de que haya olvidado algún dato de registro puede ponerse en contacto con <b><a href="mailto:elcorreoquequieres@correo.com">app.support@nexonautomation.com</a></b>.</p>
            </div>
          </div><br>
        </section>
        <!-- Final - Sección del manual de usuario (Inicio de Sesión) -->
      </main>
    </div>
  </div>
</template>

<style scoped>
  /* Estilos adicionales para asegurar que todo se vea bien */
  main {
    min-height: 100vh; /* Asegurar que el contenido tenga la altura completa */
  }

 h3 {
   text-align: center;
 }
 .bi-caret-right-fill {
  color: #db7535;
 }

 .bi-caret-right {
  color: #db7535;
 }

 .card {
  background: #f5f2f2 ;
 }

</style>
